import React, { useEffect } from 'react'
import cx from 'classnames'
import getUrl from 'front-end-core/core/url'
import { QA_CONTENT } from 'constants/controllers'
import TiledMenuConsumerContainer from 'redux/containers/components/tiled-menu/TiledMenuConsumerContainer'

export const getFlavourColor = flavour => {
  switch (flavour) {
    case 'skimmed':
      return 'light-coral'
    case 'semi':
      return 'light-sea-green-1'
    case 'full':
      return 'medium-turquoise'
    default:
      return 'grey'
  }
}

const QAMenu = ({
  flavour,
  aol,
  isTiledMenuLoaded,
  setQAPickedSection,
  setQARootSections,
  setTiledMenuIsLoaded,
  rootSections,
  pickedSection,
  sections,
  isMobile,
  headerHeight,
  qaSections,
  setQASections,
  ...props
}) => {
  const primaryColor = getFlavourColor(flavour)
  const cxNames = {
    tile: {
      borderColor: `b--${primaryColor}`,
      iconColor: 'cadet-blue',
      onHoverColor: `qa-tile-${props.flavour}`
    },
    popover: {
      backgroundColor: 'bg-faf-grey',
      borderColor: `b--${primaryColor}`,
      buttonColor: `bg-${primaryColor}`
    }
  }

  useEffect(() => {
    setQASections(qaSections)
  }, [qaSections, setQASections])

  useEffect(() => {
    setQAPickedSection(flavour, sections)
  }, [flavour, sections])

  useEffect(() => {
    setQARootSections(pickedSection)
  }, [pickedSection])

  return (
    <div className={cx('bg-ghost-grey')}>
      <div className='layout-width-constraint pt8 pa7'>
        {rootSections && pickedSection && (
          <TiledMenuConsumerContainer
            {...{ ...props, flavour, cxNames }}
            tiledMenu={{ rootSections, nodes: { ...pickedSection } }}
            getUrl={params => getUrl(QA_CONTENT, { aol, flavour, ...params })}
            data-help-item='qatiles'
            category='Q&amp;A'
          />
        )}
      </div>
    </div>
  )
}

export default QAMenu
